import { cssUtil } from "../../utils/cssUtil.js";
import { getBaseStyles } from "../commonStyles.js";

export async function renderMenuContainerWidget(context, widget, parent, override = null) {

    const el = context.document.createElement("div");
    el.classList.add("widget", "menu_container_widget");

    const breakpoint = context.currentBreakpoint;

    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    // Menu alignment comes from parent Menu widget
    const menuWidget = context.widgets.find(w => w.uid === widget.parent);
    const menuProps = menuWidget?.properties?.desktop;
    const alignment = menuProps?.alignment;

    if (alignment) {
        const position = alignment.position;
        const margin = Math.max(0, parseInt(alignment.margin ?? "0", 10));

        styles["text-align"] = position;

        if (position === "left") {
            styles["padding-left"] = `${margin}px`;
        } else if (position === "right") {
            styles["padding-right"] = `${margin}px`;
        }
    }

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);

    // Menu content wrapper
    const menuContentEl = context.document.createElement("div");
    menuContentEl.classList.add("menu_content");
    menuContentEl.setAttribute(
        "style",
        cssUtil.toStyleString({ width: "auto" })
    );

    el.appendChild(menuContentEl);
    parent.appendChild(el);

    // Render menu items
    const menuItems = widget?.content;
    if (!menuItems || !menuItems.length) return el;

    for (const item of menuItems) {
        const itemEl = context.document.createElement("div");
        itemEl.classList.add("menu_item");

        const buttonStyles = getButtonStyles(widget);
        itemEl.setAttribute("style", cssUtil.toStyleString(buttonStyles));

        itemEl.innerHTML = item.name;

        menuContentEl.appendChild(itemEl);
    }

    return el;
}

export function getButtonStyles(widget) {
    const props = widget?.properties?.desktop;
    if (!props) return {};

    const regular = props.regular;
    const button = regular?.menuStyles;

    const styles = {};

    // spacing between menu items
    styles["margin-right"] = `${props.padding}px`;

    styles["padding-left"] = `${props.itemHorizontalPadding}px`;
    styles["padding-right"] = `${props.itemHorizontalPadding}px`;
    styles["padding-top"] = `${props.itemVerticalPadding}px`;
    styles["padding-bottom"] = `${props.itemVerticalPadding}px`;

    // Font color
    const fontColor = cssUtil.getCssColor(button?.font?.color);
    if (fontColor) {
        styles.color = fontColor;
    }

    // Background
    const bg = button?.background;
    if (bg?.type === "color") {
        styles["background-color"] = cssUtil.getCssColor(bg);
    }
    if (bg?.type === "gradient") {
        styles["background"] = cssUtil.getCssGradient(bg);
    }

    applyFontStyles(styles, button);
    applyBorderStyles(styles, button);

    return styles;
}

export function applyFontStyles(styles, button) {
    const font = button?.font;
    if (!font) return;

    if (font.fontFamily) styles["font-family"] = font.fontFamily;
    if (font.fontSize) styles["font-size"] = `${font.fontSize}px`;
    if (font.lineSpacing) styles["line-height"] = `${font.lineSpacing}em`;
    if (font.letterSpacing) styles["letter-spacing"] = `${font.letterSpacing}em`;

    if (font.style?.bold) styles["font-weight"] = "bold";
    if (font.style?.italic) styles["font-style"] = "italic";
    if (font.style?.underline) styles["text-decoration"] = "underline";
}

export function applyBorderStyles(styles, button) {
    const border = button?.border;
    if (!border) return;

    const radius = border.radius;

    if (radius?.topLeft) styles["border-top-left-radius"] = `${radius.topLeft}px`;
    if (radius?.topRight) styles["border-top-right-radius"] = `${radius.topRight}px`;
    if (radius?.bottomRight) styles["border-bottom-right-radius"] = `${radius.bottomRight}px`;
    if (radius?.bottomLeft) styles["border-bottom-left-radius"] = `${radius.bottomLeft}px`;

    if (border.width) styles["border-width"] = `${border.width}px`;

    if (border.color?.type === "color") {
        styles["border-color"] = cssUtil.getCssColor(border.color);
    }

    if (border.color?.type === "gradient") {
        styles["border-image"] = cssUtil.getCssGradient(border.color);
    }
}